/**
 * Taggers die voor een taggingteam in de wedstrijd van een andere club
 * werken (docs/TAGGER-OPDRACHTEN.md). De webapp stuurt dan de kop
 * `X-Tagging-Assignment` mee; arch zet de gebruiker voor die aanroep in de
 * club van de wedstrijd, maar alleen voor de aanroepen die daarvoor
 * gemarkeerd zijn (`[AllowInTaggingAssignment]`). Met de kop naar een andere
 * aanroep geeft 403, dus de kop gaat alleen mee naar deze lijst -- dezelfde
 * als op de server.
 */
export const TAGGING_KOP = 'X-Tagging-Assignment';

const TOEGESTAAN: Record<string, RegExp[]> = {
  GET: [
    /^match\/(formations|[^/]+)$/,
    /^match\/[^/]+\/lineup$/,
    /^clubalbum(\/(data|[^/]+))?$/,
    /^players(\/(positions|[^/]+))?$/,
    /^storage\/token$/,
    /^events(\/(actions|[^/]+))?$/,
    /^events\/schema\/(panels|actions|taggingtool)(\/[^/]+)?$/,
    /^events\/schema\/(actiontags|getsubpaneldata)$/,
    /^videos(\/[^/]+)?$/,
  ],
  POST: [/^events$/],
  PATCH: [/^events\/[^/]+$/],
  DELETE: [/^events\/[^/]+(\/comment)?$/],
  PUT: [/^videos\/[^/]+\/view$/],
};

/** `pad` zonder de API-basis en zonder query, bijv. "Events/Schema/Panels". */
export function magInOpdracht(methode: string, pad: string): boolean {
  const schoon = (pad ?? '').replace(/^\/+|\/+$/g, '').split('?')[0].toLowerCase();
  // Het Match-overzicht en de import horen er niet bij, ook al lijken ze op
  // "match/<sid>".
  if (/^match\/(import|search)(\/|$)/.test(schoon)) {
    return false;
  }
  return (TOEGESTAAN[(methode ?? '').toUpperCase()] ?? []).some((re) => re.test(schoon));
}

/**
 * Pagina's waar een geopende opdracht geldt: de wedstrijd zelf, de video's
 * van de wedstrijd en de videospeler (die staat op /videos/<video>, zonder
 * de wedstrijd in het adres). Elders -- ook de lijst Tagging zelf -- geldt
 * hij niet meer.
 */
export function isOpdrachtRoute(url: string | null | undefined): boolean {
  const pad = (url ?? '').split(/[?#]/)[0].replace(/\/+$/, '');
  if (/^\/matches\/(?!add$)[^/]+(\/advanced)?$/.test(pad)) {
    return true;
  }
  if (/^\/videos\/matches\/[^/]+$/.test(pad)) {
    return true;
  }
  return /^\/videos\/(?!los$|pending$|matches$)[^/]+$/.test(pad);
}
